<section class="flex flex-row justify-center items-center">
  <div  class="w-40 flex flex-col justify-center items-center space-y-2.5 spinnerContainer">
    <mat-spinner color="accent" diameter="40"></mat-spinner>
    <span>{{ msg || '..lädt..' }}</span>
  </div>
</section>
